

import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({
  components: {DatabasePicker}
})
export default class TakipBorcluPicker extends Mixins(SimpleInputMixin) {
  @Prop({required: true}) takipId!: number;
  @Prop() label!: string;
  @Prop() rules!: any;
  @Prop() clearable!: string | boolean;

  get isClearable() {
    return this.clearable || this.clearable === "";
  }

  get displayItems(): any[] {
    const storeName = this.$helper.getTakipStoreName(this.$route.path);
    if (storeName === 'takipDetay') {
      return this.$store.getters['takipDetay/borclular'] || [];
    }
    const wrapper = this.$store.getters['takipEkle/takipBorclular'];
    return (wrapper && Array.isArray(wrapper.data)) ? wrapper.data : [];
  }

  itemText(item: any): string {
    if (!item) return '';
    if (item.ad || item.soyad) {
      return `${item.ad ?? ''} ${item.soyad ?? ''}`.trim();
    }
    return item.sirket_adi ?? '';
  }

  @Watch('displayItems', { immediate: true })
  onDisplayItemsChange(newItems: any[]) {
    if (newItems && newItems.length === 1 && !this.localValue) {
      this.localValue = newItems[0].id;
      this.$nextTick(() => this.input());
    }
  }

  load() {
    // no-op retained for backward compat with any stray callers
  }
}
